import styled from 'styled-components'

const Wrapper = styled.section`

`
export default Wrapper
